<template>
  <a-card :bordered="false">
    <!-- v-has:dealerCreate="()=> {$router.push('/antiFleeingGoods/warehouseOut/fast_out')}" -->
    <a-button type="primary" v-has:antiWarehouseOutAddFast="fastShipping">
      <PlusOutlined />
      快速调仓
    </a-button>
    <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="transfer_warehousing_sn">调仓单号</a-select-option>
            <a-select-option value="warehouse_position">调仓仓库</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='transfer_warehousing_sn' :columns='columns' :data-source='list' class="tableFixBox" :scroll="{ x: 'max-content'}">
      <template v-slot:to="{ record }">
        <p>{{record.transfer_to_warehouse_name}}</p>
        {{record.transfer_to_warehouse_position_id_name}}
      </template>
      <template v-slot:product_name="{ record }">
        <div v-if='record.product.length == 1' >
          <div v-for="(item,index) in record.product" :key='index'>
            <a-card-meta>
              <template #description>{{!item.product_sku_name || item.product_sku_name=='0' ? '单规格':item.product_sku_name}} - {{item.product_name}}</template>
            </a-card-meta>
          </div>
        </div>
        <div class="s_flex_ali" v-else>
          <p class="m-l-5 m-r-10">多商品</p>
          <a-button type="primary" size="small" @click='targetList=record.product;goodDetailVisible=true'>查看商品详情</a-button>
        </div>
      </template>
      <template v-slot:real_num="{record}">
          <p @click="codeDetailVisible=true;targetId=record.transfer_warehousing_sn" style="color:#f04635;cursor: pointer;">
            {{record.real_num}}</p>
      </template>
      <template v-slot:action="{ record }">
          <a href="javascript:;" class="m-r-10" v-has:storehouseDetail="()=> {$router.push('/antiFleeingGoods/storehouseDetail?id='+record.transfer_warehousing_sn)}">详情</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <a-modal :keyboard="false" :maskClosable='false' v-model:visible="showAction" destroyOnClose :footer='null' centered>
    <p class="text-ac s_font_b fz-18 m-b-20">您还有未完成发货的出货单，是否继续上一次的编辑？</p>
    <p class="text-ac m-b-50">选择继续当前操作，未完成的单据将进行取消操作</p>
    <div class="text-ac">
      <a-button @click="selectAction('goOn')">继续当前操作</a-button>
      <a-button type="primary" class="m-l-20" @click="selectAction('goBack')">返回上一次编辑</a-button>
    </div>
  </a-modal>
    <a-modal :keyboard="false" :maskClosable='false' v-model:visible="codeDetailVisible" destroyOnClose :footer='null' :width="1200" centered>
      <codeDetail  :id="targetId"/>
  </a-modal>
  <a-modal title='商品详情' :keyboard="false" :maskClosable='false' v-model:visible="goodDetailVisible" destroyOnClose :footer='null' :width="1200" centered>
    <goodDetail  :listdata="targetList"/>
  </a-modal>
</template>
<script>
import {  PlusOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message, Modal } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getDealerLevelList } from "@/api/dealer";
import { iscode } from "@/utils/app";
import useTableSearch from "@/hooks/useTableSearch";
import codeDetail from './components/codeDetail'
import goodDetail from '../components/goodDetails.vue'
import {
  transferWarehousing,
  closeOutWarehousing,
  outWarehousingClose,
  editFast,
  closeRefundOrder,
} from "@/api/antiFleeing";
import store from "@/store";
// 初始化默认筛选项数值
let defSearch = {
  start_time: "",
  end_time: "",
  page: 1,
  limit: 10,
  key_type: "transfer_warehousing_sn",
  keyword: ""
};
export default {
  components: { PlusOutlined,codeDetail ,goodDetail},
  setup() {
    const state = reactive({
      info: store.state.user.info,
      time: [],
      showAction: false,
      itemId: "", //上一次订单
      status: false, //false 调仓 true 快速
      currentOrder: "", //当前订单
      goodDetailVisible:false,
      transfer_status:2
    });
    let columns = [
      {
        title: "调仓单号",
        dataIndex: "transfer_warehousing_sn",
        key: "transfer_warehousing_sn",
      },
      {
        title: "调仓仓库",
        dataIndex: "to",
        key: "to",
        slots: { customRender: "to" },
      },
      {
        title: "商品信息",
        dataIndex: "product_name",
        key: "product_name",
        slots: { customRender: "product_name" },
        width:300
      },
      {
        title: "调仓数量",
        dataIndex: "num",
        key: "num",
        customRender:function({record}){
          return record.create_type==1?'-':(record.num || '-')
        }
      },
      {
        title: "实际数量",
        dataIndex: "out_warehousing_real_num ",
        key: "out_warehousing_real_num ",
        slots: { customRender: "real_num" },
      },
      {
        title: "类型",
        dataIndex: "create_type_text",
        key: "create_type_text",
      },
      {
        title: "状态",
        dataIndex: "transfer_status_text",
        key: "transfer_status_text",
      },
      {
        title: "创建时间",
        dataIndex: "created_at",
        key: "created_at",
      },
      {
        title: "操作",
        key: "action",
        fixed: 'right',
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const changTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    //快速出货
    const fastShipping = async () => {
      // state.status = true;
      // let res = await editFast().then((res) => res.data).catch(error => error);
      //  if (iscode(res)) {
      //     const {order_no} =res.data;
      //      if(order_no!=0){ //有上次订单
      //          state.itemId = order_no;
      //          state.showAction = true
      //      }else{
      //         $router.push('/antiFleeingGoods/warehouseOut/fast_out')
      //      }
      //  }else{
      //     message.error(res.msg);
      //  }
      $router.push("/antiFleeingGoods/storehouse/fastStoreHouse");
    };

    // 选择操作
    const selectAction = async (type) => {
      if (type == "goOn") {
        const hide = message.loading("正在加载中...", 0);
        let res = await closeRefundOrder(state.itemId)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(res)) {
          //快速调仓和调仓
          state.status
            ? $router.push("/antiFleeingGoods/warehouseOut/fast_out")
            : $router.push(
                "/antiFleeingGoods/warehouseOut/ordinary_out?id=" + state.itemId
              );
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      } else {
        $router.push(
          "/antiFleeingGoods/warehouseOut/ordinary_out?id=" + state.itemId
        );
      }
    };
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    // 查看二维码详情
    const codeDetailVisible=ref(false)
    const targetId=ref('')

    // 删除
    const del=(item)=>{
          Modal.confirm({
        centered: true,
        content: "确定关闭订单？",
        onOk: async () => {
          let res = await outWarehousingClose(item.transfer_warehousing_sn).then((res) => res.data);
          if (iscode(res, true)) {
            pageSearchChange();
          }
        },
      });
    }
    onMounted(() => {
      tableHoosks.initData(transferWarehousing, search.value);
    });
    return {
      ...toRefs(state),
      ...tableHoosks,
      codeDetailVisible,
      targetId,
      columns,
      changTime,
      selectAction,
      fastShipping,
      del
    };
  },
};
</script>